export default __webpack_public_path__ + "static/media/alarm.01be3ee7.mp3";